import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';

import { VSpacer } from '@nx-smartmonkey/ui';
import { capacitorService } from '../../../../application/CapacitorService';
import { storageService } from '../../../../application/StorageService';
import { Modal } from '../../../../components/Modal';
import Button from '../../../../react-components/Button';
import { Text } from '../../../../react-components/Text';

interface AppInformationProps {
  open: boolean;
  onClose: () => void;
}
const APP_UPDATE_DISMISSED = `APP_UPDATE_DISMISSED`;
export const AppInformation = ({ open, onClose }: AppInformationProps) => {
  const [dismissedVersion, setDismissedVersion] = useState<string | null>(null);

  useEffect(() => {
    const fetchLocalVersion = async () => {
      try {
        const res = await storageService.getItem({ key: APP_UPDATE_DISMISSED });
        setDismissedVersion(res);
      } catch (error) {
        console.error(`Error fetching local version:`, error);
      }
    };

    fetchLocalVersion();
  }, []);

  const currentVersion = capacitorService.getPlatformVersion();
  const storeVersion = capacitorService.getStoreVersion();
  const hasUpdate = capacitorService.hasUpdatedVersion();

  const handleUpdate = () => {
    capacitorService.openAppStore();
  };

  return (
    <Modal open={open} title={{ intlId: `drivers.app_information.title` }} onBackgroundClick={onClose}>
      <VSpacer medium />
      <Grid container direction="column" alignItems="flex-start" alignContent={`flex-start`}>
        <Text intlId="drivers.app_information.app_version" intlValues={{ version: currentVersion }} />
        <VSpacer small />
        <Text intlId="drivers.app_information.store_version" intlValues={{ version: storeVersion ?? `` }} />
        <VSpacer small />
        {dismissedVersion && (
          <>
            <Text intlId="drivers.app_information.last_dismissed_version" intlValues={{ version: dismissedVersion }} />
            <VSpacer small />
          </>
        )}

        {hasUpdate && (
          <>
            <VSpacer small />
            <Grid item display={`flex`} width={`100%`} justifyContent="center">
              <Button
                variant="contained"
                color="primary"
                onClick={handleUpdate}
                intlId="drivers.app_information.update"
                style={{ margin: 0, height: `30px` }}
              />
            </Grid>
          </>
        )}
      </Grid>
    </Modal>
  );
};
